export default __webpack_public_path__ + "static/media/bus_black.71a799de.svg";